export default "__VITE_ASSET__Rwhd9bOE__"